import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as healthCheck from '../../health-check'

export const RESOURCE = {
  payload: {
    description:
      'A specific area of focus and method of grouping questions at a lower level of a health check assessment, such as Strategic Planning and Strategic Deployment.',
    dimension: healthCheck.RESOURCE.payload,
    level: 2,
    name: 'Dimension',
    partialId: PartialId.Standard.create('dimension'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
